import { jwtDecode } from 'jwt-decode'

/**
 * The claims of a decoded token.
 */
export interface TokenClaims {
  sub: string
  iss: string
  'https://worklayer.com/claims.mfa_enrolled'?: unknown
}

/**
 * Decodes a token's claims without verifying it.
 */
export function decodeTokenClaims(token: string) {
  return jwtDecode<TokenClaims>(token)
}

/**
 * Whether the token's user has enrolled in multi-factor authentication.
 */
export function isMfaEnrolled(claims: TokenClaims) {
  return Boolean(claims['https://worklayer.com/claims.mfa_enrolled'])
}
